// extracted by mini-css-extract-plugin
export default {"steps":"TB-z","header":"UB-z","description":"VB-z"};